import React from 'react';
import Paper from "@material-ui/core/Paper/Paper";

import locales from "../locales";
import PageContentWrap from '../components/Common/PageContentWrap';
import Title from "../components/Common/Title";

import {Offer, Channels} from "../widgets";


const GuestAcquisitionPage: React.FC = () => (
  <>
    <Paper elevation={3}>
      <Title
        text={locales.t('guestAcquisition.title')}
        borderBottom
      />
    </Paper>
    <PageContentWrap fullWidth spacing={0}>
      <Offer/>
      <Channels/>
    </PageContentWrap>
  </>
);

export default GuestAcquisitionPage;
